<template>
  <div class='login'>
      <el-image
      :src="require('@/assets/images/home/login_bg.png')"
      width='450'
      height='450'
       />

       <div class='login_mark'>
           <img src='@/assets/images/home/login_logo.png' />
           <LoginInput
            :label="$t('Login.username')"
            :appendIcon="require('@/assets/images/home/icon_username.png')"
            :placeholder="$t('Login.placeholdName')"
            @changeInput='usernameChange' />

           <LoginInput
            :label="$t('Login.pwd')"
            :appendIcon="require('@/assets/images/home/icon_password.png')"
            :placeholder="$t('Login.placeholdPwd')"
            type='password'
            inputStyle='margin-top: 24px;'
            @changeInput='passwordChange' />

           <LoginInput
            :label="$t('Login.googleCheckcode')"
            :appendIcon="require('@/assets/images/home/icon_checkcode.png')"
            :placeholder="$t('Login.checkDesc')"
            type='number'
            inputStyle='margin-top: 24px;'
            :bottomTip="$t('Login.checkTip')"
            @changeInput='googleChange' />

            <div class="slide-container">
              <SlideVerify ref="slidVer" @verify_pass="verify_pass" />
            </div>

       <button @click="loginClick">{{$t('Login.login')}}</button>
       </div>
  </div>
</template>

<script>
import LoginInput from '@/components/loginInput.vue';
import { setToken } from '@/utils/storge';
import SlideVerify from '@/components/SlideVerify.vue';
import { toLogin } from '@/service/requestRes';

export default {
  components: {
    LoginInput,
    SlideVerify,
  },
  data() {
    return {
      msg: '',
      email: '',
      password: '',
      google: '',
    };
  },
  created() {
    console.log('login');
  },
  methods: {
    usernameChange(e) {
      this.email = e;
    },
    passwordChange(e) {
      this.password = e;
    },
    googleChange(e) {
      this.google = e;
    },
    loginClick() {
      if (!this.email) {
        this.$message({
          message: '请输入用户名',
          type: 'error',
        });
        return;
      }

      if (!this.password) {
        this.$message({
          message: '请输入密码',
          type: 'error',
        });
        return;
      }
      if (!this.msg) {
        this.$message({
          message: '请滑动验证',
          type: 'error',
        });
        return;
      }

      this.$refs.slidVer.clean();
      this.msg = '';
      toLogin({ email: this.email, password: this.password, google: this.google }).then((res) => {
        let { data, code, msg } = res || {};
        if (code === 1) {
          setToken(data.token);
          this.$router.replace('/');
        } else {
          
           const { locale } = this.$i18n;
          if (msg.indexOf('不正确') != -1  && locale === 'en_US') {
            msg = 'Login or password error';
          }
          
          if (msg.indexOf('过期') != -1  && locale === 'en_US') {
            msg = 'token expired';
          }
          
          msg && this.$message({
            message: msg,
            type: 'error',
          });
        }
      });
    },
    verify_pass() {
      this.msg = 'pass';
      console.log('~~~~~~~pass');
    },
  },
};
</script>

<style lang="scss" scoped>
    .login {
        background: #F5F6FA;
        display: flex;
        align-items: center;
        height: 100vh;
        padding-left: 156px;
        .login_mark {
            width: 540px;
            background-color: white;
            padding: 60px;
            margin-left: 103px;
            text-align: center;

            .slide-container {
              margin-top: 18px;
            }
            button {
                width: 100%;
                height: 48px;
                background: #1E5EFF;
                border-radius: 4px;
                border-radius: 4px;
                font-family: PingFangSC-Semibold;
                font-size: 16px;
                color: #FFFFFF;
                letter-spacing: 0;
                text-align: center;
                margin-top: 46px;
            }
        }
        .login_mark img {
            margin-bottom: 24px;
        }
    }
</style>>
